export default __webpack_public_path__ + "static/media/gallery-image-12.b0494e30.jpg";